import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.3332 7.33366H5.21984L8.9465 3.60699L7.99984 2.66699L2.6665 8.00033L7.99984 13.3337L8.93984 12.3937L5.21984 8.66699H13.3332V7.33366Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgArrowBack);
export { ForwardRef as ReactComponent };
